export const ROLES = {
  CREATOR: 'creator',
  ADMIN: 'admin',
  BRAND: 'brand',
};

export const ADMIN_MODULES = ['admin-dashboard', 'admin-users', 'admin-nav', 'admin-user-detail', 'admin-activity-overview'];
